import clsx from 'clsx';
import {Link} from 'react-router-dom';
import {LocalCafeIcon} from '../../icons/material/LocalCafe';

interface Props {
  className?: string;
  padding?: string;
}

export function Footer({className, padding}: Props) {
  const year = new Date().getFullYear();

  return (
    <footer
      className={clsx(
        'w-full border-t border-slate-200/80 dark:border-divider bg-white dark:bg-alt text-sm transition-colors min-h-[72px] flex items-center justify-center relative',
        padding ? padding : 'py-12 px-16 md:px-28',
        className,
      )}
    >
      <div className="w-full flex flex-col md:flex-row items-center justify-center gap-16 relative">
        {/* Center: TDMU Logo + Info */}
        <div className="flex items-center gap-14 text-center sm:text-left justify-center">
          <img
            src="/images/tdmu-logo.svg"
            alt="Trường Đại học Thủ Dầu Một"
            className="h-32 md:h-38 w-auto object-contain flex-shrink-0"
          />
          <div className="h-28 w-px bg-slate-200 dark:bg-divider hidden sm:block flex-shrink-0" />
          <div className="flex flex-col text-xs md:text-sm leading-relaxed text-slate-600 dark:text-muted">
            <div className="text-slate-800 dark:text-main font-medium">
              <strong className="font-bold text-slate-900 dark:text-main">TDMU.DEV - URL Shortener</strong>
              {' © '}
              {year}
              {' • Trường Đại học Thủ Dầu Một'}
            </div>
            <div className="text-slate-600 dark:text-muted" style={{fontSize: '1.03rem'}}>
              Hệ thống được phát triển và vận hành bởi{' '}
              <a
                href="mailto:nguyentanloi@tdmu.edu.vn"
                className="font-bold text-[#0284c7] hover:underline transition-colors"
                title="Email: nguyentanloi@tdmu.edu.vn"
              >
                Nguyễn Tấn Lợi
              </a>
            </div>
          </div>
        </div>

        {/* Right: Buy me a coffee button */}
        <div className="md:absolute md:right-0 flex items-center gap-10 flex-shrink-0">
          <Link
            to="/donate"
            className="inline-flex items-center gap-6 px-16 py-7 rounded-full border border-[#fde68a] bg-[#fffbeb] hover:bg-[#fef3c7] text-[#92400e] dark:bg-amber-950/40 dark:border-amber-700/80 dark:text-amber-300 dark:hover:bg-amber-900/60 font-semibold text-xs md:text-sm shadow-sm transition-all duration-200 cursor-pointer active:scale-95 no-underline"
          >
            <LocalCafeIcon className="text-amber-600 dark:text-amber-400 w-16 h-16" />
            <span>Mời Cà phê</span>
          </Link>
        </div>
      </div>
    </footer>
  );
}
